import { useState } from 'react';

import { rewriteImageSrc } from '@/utils/rewriteImageSrc';

import { Image } from '../image';
import type { BackgroundImageProps } from './backgroundImage.type';

export function BackgroundImage({
  src,
  darken,
  overlayColor,
  optimizable,
  optimizedImageComponent: ImageComponentProp,
}: BackgroundImageProps) {
  const [isError, setIsError] = useState(false);

  if (!src) return null;

  const ImageComp = ImageComponentProp || Image;
  const darkenValue = typeof darken === 'boolean' ? (darken ? 0.4 : 0) : darken || 0;
  const hasOverlay = darkenValue > 0;

  return (
    <>
      <ImageComp
        src={rewriteImageSrc(src)}
        alt="background"
        layout="fill"
        objectFit="cover"
        objectPosition="center"
        priority
        onError={() => setIsError(true)}
        unoptimized={!optimizable || isError ? true : undefined}
        quality={100}
        style={{
          width: '100%',
          height: '100%',
        }}
      />
      {hasOverlay && (
        <div
          style={{
            position: 'absolute',
            inset: 0,
            backgroundColor: overlayColor || '#000000',
            opacity: darkenValue,
            pointerEvents: 'none',
          }}
        />
      )}
    </>
  );
}
